import { AppConfigContextType } from '../contexts/AppConfigContext.types';
import { MenuListType } from './common.types';

// dev:
// export const BASE_URL = 'https://storage.yandexcloud.net/kitchen.test';

// prod:
export const BASE_URL = 'https://storage.yandexcloud.net/wemakekitchen-data';

// dev:
// export const accessKeyForMessages = '32b73506-3c92-4e9b-ab5d-1824828b61f5';

// prod:
export const accessKeyForMessages = 'a8e9f3bd-7147-469c-b924-eaaa1ceca68f';

export const MENU_LIST: MenuListType = {
  portfolio: 'Портфолио',
};

export const DEFAULT_CONFIG: AppConfigContextType = {
  logo: 'WE MAKE KITCHEN',
  logoExtraText: 'кухни и мебель на заказ',
  phoneNumber: '8 911 242 86 25',
  email: 'wemakekitchen@mail.ru',
  telegram: 'https://t.me/Chernikov_design',
  whatsapp: 'https://wa.me/79112428625',
  instagram:
    'https://www.instagram.com/we_make_kitchen?igsh=MTMydjJuMGRkZDE4Mg==',
  youtube: 'https://www.youtube.com/channel/UCnARQcLGP9lve6-DO7GqwGQ',
  vk: 'https://vk.com/club229915303',
  organization: 'ИП ЧЕРНИКОВ П.П.',
  OGRN: 'ОГРН 325784700114164',
  aboutAsText:
    '<p>WE MAKE KITCHEN — это воплощение современной кухонной эстетики в стиле минимализма.</p><p>Наш бренд создаёт уникальные индивидуальные проекты, учитывающие потребности каждого клиента. Мы предлагаем вам кухню, передающую притягательность лаконичного стиля и ясность форм. Природные оттенки, натуральные материалы и чистая геометрия линий создают пространство, наполненное гармонией и спокойствием.</p><p>Минималистичный дизайн помогает акцентировать внимание на главном, делая интерьер современным, стильным и универсальным. Индивидуальные проекты от WE MAKE KITCHEN позволяют создавать идеальное пространство, которое отражает ваш личный стиль и предпочтения. Функциональность решений и продуманная эргономика делают нашу продукцию удобной и комфортной в повседневном использовании, подчеркивая вкус и утончённость её владельца.</p>',
  draftProject: {
    id: 'luzhki',
    name: 'LUZHKI',
    year: '2025',
    location: 'Saint-Petersburg',
    area: '150',
    heroImage: 'luzhki',
  },
  projects: [
    {
      id: 'savushkina_133',
      num: '1',
      name: 'SAVUSHKINA 113',
      year: '2025',
      location: 'Saint-Petersburg',
      area: '76',
      heroImage:
        'https://storage.yandexcloud.net/kitchen.test/portfolio/savushkina_133/004.jpg',
      designer: {
        name: 'Chernikov Design',
        contact: 'chernikovdesign@mail.ru',
        photo:
          'https://storage.yandexcloud.net/kitchen.test/designers/chernikov.jpg',
        description:
          '<p>Данный проект представляет собой современное решение для организации кухонного пространства, объединенного с гостиной зоной. Интерьер выполнен в минималистичном стиле с элементами скандинавского дизайна, что создает ощущение простора, легкости и функциональности.</p><p>Мы используем нейтральные, чистые и природные оттенки, простые формы и четкую геометрию, а так же конструктивные особенности современного Датского и Шведского дизайна.</p><p>Такой дизайн делает интерьер элегантным, благородным и неустаревающим, наполняет дом уютом и комфортом, при этом не стремится забрать все внимание на себя, а лишь подчеркивает утонченность его владельцев.</p>',
      },
    },
  ],
};
